const headings = {
  1: {
    fontSize: '3rem',
    fontWeight: 600,
  },
  2: {
    fontSize: '2.75rem',
    fontWeight: 600,
  },
  3: {
    fontSize: '4rem',
    fontWeight: 600,
  },
  4: {
    fontSize: '2rem',
    fontWeight: 600,
  },
  5: {
    fontSize: '1.25rem',
    fontWeight: 400,
  },
}

const lightTheme = {
  transition: '0.37s',
  mainBgColor: '#f9f9f9',
  header: {
    bgColor: '#f9f9f9',
    textColor: '#05233b',
    accentColor: '#3490dc'
  },
  textColor: '#05233b',
  accentColor: '#6128d3',
  headings
};

const darkTheme = {
  transition: '0.37s',
  bgColor: '#00173a',
  lightBgColor: 'hsl(216, 10%, 90%, 1)',
  header: {
    bgColor: '#00173a',
    textColor: '#247393',
    accentColor: 'hsla(216, 80%, 41%, 1)',
    subMenu: {
      bgColor: '#11536e ',
      textColor: 'hsl(161, 52%, 75%, 1)',
      accentColor: '#247393'
    }
  },
  footer: {
    bgColor: '#00173a',
    textColor: 'hsl(216, 20%, 80%, 1)',
    accentColor: 'hsla(216, 80%, 41%, 1)'
  },
  postList: {
    dateColor: '#00173a',
    textColor: '#00173a',
    titleColor: 'hsla(216, 80%, 41%, 1)'
  },
  textColor: '#00173a',
  lightTextColor: 'hsl(216, 20%, 80%, 1)',
  accentColor: '#6128d3',
  headings,
  buttons: {
    primary: {
      bgColor: '#00173a',
      color: 'hsl(216, 20%, 80%, 1)',
    },
    secondary: {
      bgColor: 'hsl(216, 20%, 80%, 1)',
      color: '#00173a',
    },
  },
  buttonsSize: {
    small: {
      fontSize: '0.75rem',
      fontWeight: 400,
      padding: '0.25rem 0.75rem',
    },
    normal: {
      fontSize: '1rem',
      fontWeight: 500,
      padding: '0.5rem 1rem',
    }
  },
  borderRadius: {
    rounded: '0.25rem'
  },
  fontFamilies: {
    monoSpace: 'Inconsolata',
    text: 'Montserrat, Helvetica, Arial, Lucida, sans-serif',
    title: 'Ubuntu'
  },
  boxShadow: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  },
  screens: {
    'sm': '640px',
    'md': '768px',
    'lg': '1024px',
    'xl': '1280px',
    'xxl': '1600px',
  }
};

export { darkTheme, lightTheme }